export default __webpack_public_path__ + "static/media/Dollar.36a6a218.svg";